import React, {ReactElement} from "react";
import BranchList, {BranchSummaryRow} from "check/check-preparation/BranchList";
import {NxTableColumn} from "@nextbank/ui-components";
import NxPage from "form/NxPage";
import NxHeader from "form/NxHeader";

const columns: NxTableColumn<BranchSummaryRow>[] = [{
  title: "No",
  field: "no",
}, {
  title: "Branch",
  field: "name",
}, {
  title: "No of outgoing checks",
  field: "noOfOutgoingChecks",
}];

const OutgoingChecksBranchList = (): ReactElement => {
  return <NxPage>
    <NxHeader>
      Outgoing Checks
    </NxHeader>
    <BranchList redirect={(selectedBranch : BranchSummaryRow) : string => { return `/check-preparation/outgoing-checks/${selectedBranch.id}`}}
                columns={columns}/>
  </NxPage>
};

export default OutgoingChecksBranchList;